<script type="text/javascript">
    window.onload = detectarCarga;

    function detectarCarga() {
        document.getElementById("preloader").style.display = "none";
    }
</script>
<div id="preloader">
    <div id="loader"></div>
</div>